import React, {useEffect, useState} from "react";
import axios from 'axios';

import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaFacebook } from 'react-icons/fa';

export default function Footer() {
  const [about, setAbout] = useState([])

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_STRAPI_API_URL}/about?populate=*`, {
      headers: {
        Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
      }
    }).then(res => {
      setAbout(res.data.data);
    }).catch(err => console.error(err));
  }, [])



  return (
    <footer className="bg-gray-900 text-white py-10 px-4">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h3 className="text-xl font-bold mb-4">VeraLeaf</h3>
          <p>{about.slogan}</p>
        </div>
        <div>
          <h4 className="font-semibold mb-2">Liên hệ</h4>
          <ul className="space-y-2">
            <li className="flex items-center gap-2">
              <FaEnvelope />
              <a href="mailto:{about.email}" className="hover:text-yellow-400">{about.email}</a>
            </li>
            <li className="flex items-center gap-2">
              <FaPhone />
              <a href="tel:{about.phone_number}" className="hover:text-yellow-400">{about.phone_number}</a>
            </li>
            <li className="flex items-start gap-2">
              <FaMapMarkerAlt className="mt-1" />
              <span>{about.address}</span>
            </li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-2">Mạng xã hội</h4>
          <ul className="space-y-2">
            <li>
              <a target="_blank" rel="noopener noreferrer" href={about.facebook} className="hover:underline">
                <FaFacebook className="text-3xl"/>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="text-center mt-10 text-sm text-gray-400">&copy; 2025 Vera Leaf. All rights reserved.</div>
    </footer>
  );
}
